import { FC } from 'react';

interface FlowPathGroupChipsProps {
  options: Array<{ id: string; name: string }>;
  selectedId: string;
  onSelect: (groupId: string) => void;
}

export const FlowPathGroupChips: FC<FlowPathGroupChipsProps> = ({ options, selectedId, onSelect }) => {
  if (options.length <= 1) return null;

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1">
      {options.map((g) => {
        const isActive = g.id === selectedId;
        return (
          <button
            key={g.id}
            type="button"
            onClick={() => onSelect(g.id)}
            className={[
              'shrink-0 rounded-full border px-3 py-1.5 text-sm transition-colors',
              isActive ? 'border-primary bg-primary text-primary-foreground' : 'border-border bg-card hover:bg-muted/50',
            ].join(' ')}
            aria-label={`Select path group ${g.name}`}
          >
            <span className="max-w-[220px] truncate inline-block align-middle">{g.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FlowPathGroupChips;

